import EngineerModel from "@/models/contractor/EngineerModel";
import { IEngineerState } from "./interfaces/engineer-state";

export default class EngineerState implements IEngineerState {
    public engineers: EngineerModel[] = []
}
